import { EventEmitter, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class InitService {

  constructor(
    private FCS: ConfigService,
    private FAS: AuthService
  )
  { }

  // /**
  //  * @returns Promise all di tutte le azioni da svolgere prima dell'app start
  //  */
  // Init(): Promise<any[]> {
  //   let progressId = '';
  //   const progressEmitter: EventEmitter<number> = new EventEmitter();;
  //   let value = 0;
    
  //   return new Promise<any>(async (resolve) => {
  //     try {
  //       await this.FCS.set();
  //       progressEmitter.next(value += 30)
  //     } catch (e) {
  //       console.warn(e)
  //     }
  //     resolve(true)
  //   })
  // }

    /**
   * @returns Promise all di tutte le azioni da svolgere prima dell'app start
   */
    Init(): Promise<any[]> {
      const progressEmitter: EventEmitter<number> = new EventEmitter();
      let value = 0;

      return new Promise<any>(async (resolve) => {
        try {
          await this.FCS.set();
          progressEmitter.next(value += 30);
        } catch (e) {
          console.warn(e)
        }
        const p1 = new Promise(async (resolve) => {
          try {
            await this.FAS.init();
            progressEmitter.next(value += 40)
          } catch (e) {
            console.warn(e)
          }
          resolve(true)
        })
  
        await Promise.all([p1])
        resolve(true)
      })
    }
  
}
  
  
  /**
   * Mettere la seguente riga nei providers di app.module.ts
   * { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true }],
   */
  export function initializeApp(
    appInitService: InitService) {
    return (): Promise<any> => {
      return appInitService.Init();
    };
  }
  
  /**
   * Mettere la seguente riga nei providers di app.module.ts
   * { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true }],
   */
  export function initializeAppWithPageLoader(
    appInitService: InitService) {
    return (): Promise<any> => {
      return appInitService.Init();
    };
  }
